import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from 'gatsby-link';
import { Flex, Box, Absolute } from 'rebass';
import Emoji from '../../app/components/emoji';
import theme from '../../app/themes';

export const ACTIVE_CLASS_NAME = 'activeLink';

const Client = styled(Box)`
  position: relative;

  &:before {
    content: "";
    display: block;
    float: left;
    padding-bottom: 100%;
  }
`;

const ClientLink = styled(Link)`
  outline: 0;

  &, > div:first-of-type {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  > div:first-of-type {
    background-color: ${theme.colors.brandDark};
    opacity: 0;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    transition-duration: 0;
  }

  &:hover, &:focus, &.${ACTIVE_CLASS_NAME} {
    > div:first-of-type {
      opacity: 0.6;
      transition-duration: 200ms;
    }
  }
`;

const ClientLogoWrapper = styled(Flex)`
  height: 100%;
`;

const ClientLogo = styled.img`
  height: auto;
  min-width: 70%;
  max-width: 90%;
`;

const EmojiWrapper = styled(Absolute)`
  visibility: hidden;

  .${ACTIVE_CLASS_NAME} & {
    visibility: visible;
  }
`;

const Item = ({ id, bg, image, path }) => (
  <Client
    bg={bg}
    image={image}
    w={[1, 1 / 2, 1 / 2, 1 / 2, 1 / 3, 1 / 4]}
  >
    <ClientLink
      to={path}
      activeClassName={ACTIVE_CLASS_NAME}
      tabIndex="0"
      exact
    >
      <div />
      <ClientLogoWrapper
        justify="center"
        align="center"
        px={3}
      >
        <ClientLogo
          alt={id}
          src={image}
        />
      </ClientLogoWrapper>
      <EmojiWrapper
        bottom
        right
        mr={1}
        pr={1}
        mb={1}
        pb={1}
      >
        <Emoji size={42}>
          ❤️
        </Emoji>
      </EmojiWrapper>
    </ClientLink>
  </Client>
);

Item.propTypes = {
  id: PropTypes.string.isRequired,
  bg: PropTypes.string,
  image: PropTypes.string,
  path: PropTypes.string.isRequired,
};

Item.defaultProps = {
  bg: null,
  image: null,
};

export default Item;



// WEBPACK FOOTER //
// ./src/Work/client/index.js